var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cta_ouvrir_compte"},[_c('a',{staticStyle:{"text-decoration":"none"},attrs:{"href":"/professionnels#devenez-client"}},[_c('div',{staticClass:"ouvrir-un-compte blogtextbold"},[_vm._v("OUVRIR UN COMPTE")])])])
}]

export { render, staticRenderFns }